<template>
  <div
    @click="$router.push(`/Courses/Detail/${objectData.course_id}`)"
    class="courses-container w-100"
  >
    <div class="flex">
      <div class="flex justify-space-between align-center">
        <div class="img-container mr-20">
          <img
            class="img-courses"
            :src="objectData.banner || img.ImageDefault"
            alt=""
          />
        </div>
        <div class="info-container w-100">
          <div>
            <h4 class="fw-500 c-title2">
              {{ objectData.headline }}
            </h4>
            <div class="info-teacher flex align-center">
              <img
                class="img-teacher mr-10 "
                :src="objectData?.author?.avatar || img.ImageTeacher"
                alt=""
              />
              <span class="font-size:12px">{{ objectData?.author?.fullname }}</span>
            </div>
          </div>
        </div>
        <div class="flex-shrink ml-20">
          <p class="m-0 fw-600 c-body2">
            {{ formatNumber(objectData.payment_amount) }} $
          </p>
          <p
            style="color: #8E9195;  text-decoration: line-through;line-height:1"
            class="m-0 c-tiny"
          >
            {{ formatNumber(objectData.origin_amount) }} $
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImageDefault from "@/assets/img/poster_video.png";
import PlayIcon from "@/assets/img/svg_edu/PlayIcon.svg";
import StarIcon from "@/assets/img/svg_edu/star.svg";
import ImageTeacher from "@/assets/img/img_edu/Video.png";
import { formatNumber } from "@/utils/formatData";

export default {
  name: "courses",
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  created() {
    console.log('objectData_______', this.objectData);
  },
  data() {
    return {
      img: {
        ImageDefault,
        ImageTeacher
      },
      icons: {
        StarIcon,
        PlayIcon
      }
    };
  },
  watch: {},
  methods: {
    formatNumber
  }
};
</script>
<style scoped>
.img-teacher {
  width: 37px;
  height: 37px;
  border-radius: 50%;
  object-fit: cover;
}
.courses-container {
  width: 100%;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  padding: 10px 15px 15px 15px;
}
.img-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  width: 281px !important;
  height: 128px;
}
.img-container button {
  padding: 2px 10px;
  background: #ffff;
  border-radius: 100px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 999;
}
.img-courses {
  width: 100% !important;
  height: 128px;
}
.p-text-info {
  color: #242f41;
}
</style>
